import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import MissionSection from './MissionSection';

const MissionMain = () => {
  return (
    <main>
      <Breadcrumb  subtitle="About" title="Mission"/>
      <MissionSection/>
    </main>
  );
};
export default MissionMain;